// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__1XyQq","label":"Category_label__3F6lp","content":"Category_content__3mlGJ","header":"Category_header__1ksi0","location":"Category_location__1a4qI"};